export default class StringUtils {
	/**
	 * Generate a random string
	 * @param count number of characters to generate
	 * @param chars a string with all the possible characters to choose from
	 * @returns a random string
	 */
	static random = (count: number, chars: string) => {
		if (chars.length === 0) throw Error("chars must have at least one option")
		if (chars.length > 256) throw Error("chars must have a max of 256 options")
		let result = ""
		while (result.length < count) {
			//generate a random number from 0-255
			const a = crypto.getRandomValues(new Uint8Array(1))
			const index = a[0]
			//If the number is larger than the amount of characters to choose from, we discard it and try again.
			//This takes longer, but avoids the modulo bias.
			if (index < chars.length) {
				result += chars.charAt(index)
			}
		}
		return result
	}
}
